import axios from "axios";

// baseURL：优先读构建期环境变量 VUE_APP_API_BASE，未配置时回退线上地址。
// 本地开发可在 .env.development.local 里设 VUE_APP_API_BASE=/api 并配合 devServer 代理，
// 避免直接读写线上库；生产构建不设则沿用线上默认。
const BASE_URL =
  (typeof process !== "undefined" &&
    process.env &&
    process.env.VUE_APP_API_BASE) ||
  "https://zeno.18756.net/api";

// 登出广播：token 失效（401）时清本地凭证并派发事件，由 Index.vue 复位登录态。
export const AUTH_EXPIRED_EVENT = "zeno-auth-expired";
export function clearAuthAndNotify() {
  try {
    localStorage.removeItem("zeno_token");
    localStorage.setItem("zeno_isLoggedIn", "false");
  } catch (e) {
    /* ignore */
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
  }
}

// 创建 axios 实例
const service = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
});

// Request 拦截器
service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("zeno_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response 拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code !== 0) {
      // 业务错误。code 401 = 登录态失效，清凭证并广播登出。
      if (res.code === 401) clearAuthAndNotify();
      console.error("API Error:", res.msg);
      const err = new Error(res.msg || "Error");
      err.code = res.code;
      return Promise.reject(err);
    } else {
      return res.data;
    }
  },
  (error) => {
    // HTTP 层 401（token 过期/无效）：同样清凭证并广播登出。
    if (error && error.response && error.response.status === 401) {
      clearAuthAndNotify();
    }
    console.error("Network Error:", error);
    return Promise.reject(error);
  }
);

export default service;
